/** Remove deprecated segment keys if they were copied from form data onto an API payload. */
export const omitDeprecatedSegmentWireKeys = (payload) => {
  if (!payload || typeof payload !== 'object') {
    return payload;
  }
  const next = {...payload};
  delete next.segments;
  delete next.excludeSegments;
  delete next.selectedSegments;
  return next;
};

/** Prefer `segmentExclude` when set on form; else legacy `excludeSegments` (null/undefined fall through). */
export const resolveRawSegmentExcludeFromForm = (formData) => {
  if (
    formData?.segmentExclude !== undefined &&
    formData?.segmentExclude !== null
  ) {
    return formData.segmentExclude;
  }
  return formData?.excludeSegments;
};

/** API → form: boolean when either wire key is present; else omit (`undefined`). */
export const resolveSegmentExcludeFromApi = (src) => {
  if (src?.segmentExclude !== undefined) {
    return Boolean(src.segmentExclude);
  }
  if (src?.excludeSegments !== undefined) {
    return Boolean(src.excludeSegments);
  }
  return undefined;
};

export const resolveDisplayOrderFromApi = ({
  hasDisplayOrderFromApi,
  displayOrderFromApi,
  displayFirst
}) => {
  if (hasDisplayOrderFromApi) {
    return String(displayOrderFromApi);
  }
  if (displayFirst) {
    return '';
  }
  return 0;
};

/** Flatten segment ids from grouped or flat UI `segments` (deduped). */
export const normalizeActivitySegmentInput = (input) => {
  if (!Array.isArray(input)) return [];
  try {
    const isGrouped = input.some(Array.isArray);
    const flat = isGrouped ? input.flat() : input;
    return Array.from(new Set(flat.filter(Boolean)));
  } catch {
    return [];
  }
};
